import React from "react";
import About from "./About";
import HeroSection from "./HeroSection";
import Section2 from "./Section2";
import Section3 from "./Section3";

interface Props {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const AboutPage = ({ setIsOpen }: Props) => {
  return (
    <div className="flex flex-col overflow-hidden mx-auto max-w-screen-2xl items-center justify-center">
      <HeroSection setIsOpen={setIsOpen} />
      <About />
      <Section2 />
      <Section3 />
    </div>
  );
};

export default AboutPage;
